import { connect } from "react-redux";

import { setStateHiddenColGrouping } from "../../../Engine/ActionCreators/AllActionCreators";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { getHiddenColgroupingGroupStates } from "../../../Helpers/StateAccessors/ColgroupHelpers";
import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { withTestPageObjectRegistration } from "../../Services/TestPageObjects/PageObjectExposure";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";

import { ColgroupButton } from "./ColgroupButton";

export interface ColgroupButtonContainerProps {
    bindingPath: AbsoluteModelPath;
    hiddenColgroup: string;
}

const mapStateToProps = (state: FullFormState, ownProps: ColgroupButtonContainerProps) => {
    const { bindingPath, hiddenColgroup } = ownProps;
    const hiddenColgroupingGroupStates = getHiddenColgroupingGroupStates(
        state,
        bindingPath.toLegacyPath(),
        hiddenColgroup
    );
    const hiddenColgroupState = hiddenColgroupingGroupStates.state ?? "auto";
    const hiddenColgroupFilledCount = hiddenColgroupingGroupStates.filledCount ?? 0;

    return {
        collapsed: hiddenColgroupState === "auto" ? hiddenColgroupFilledCount === 0 : hiddenColgroupState === "hide",
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch, props: ColgroupButtonContainerProps) => ({
    onCollapsedChange: (nextCollapsed: boolean) => {
        dispatch(setStateHiddenColGrouping(props.bindingPath.toLegacyPath(), props.hiddenColgroup, !nextCollapsed));
    },
});

export const ColgroupButtonContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(withTestPageObjectRegistration(ColgroupButton, x => [`${x.bindingPath.toLegacyPath()}/${x.hiddenColgroup}`]));
